module.exports = __webpack_public_path__ + "1cc8d7d8f03ed645bb287a6ad3c82242.png";